import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadTransferPdf = (transferData, companyName, setOpenBackdrop) => {
    if (!transferData || transferData.length === 0) {
        alert("No data found to generate report!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        let currentY = 15;

        // --- Header Section ---
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFontSize(12);
        doc.setTextColor(100);
        doc.text(companyName || 'COMPANY NAME', 14, 15);

        doc.setFontSize(16);
        doc.setTextColor(25, 118, 210);
        doc.setFont("helvetica", "bold");
        const title = "SITE TRANSFER REPORT";
        doc.text(title, (pageWidth - doc.getTextWidth(title)) / 2, 25);

        doc.setLineWidth(0.5);
        doc.line(14, 30, 196, 30);
        currentY = 40;

        transferData.forEach((transfer, index) => {
            if (currentY > 250) {
                doc.addPage();
                currentY = 20;
            }

            // Transfer Sub-Header (From -> To)
            doc.setFillColor(245, 245, 245);
            doc.rect(14, currentY, 182, 10, 'F');
            doc.setFontSize(10);
            doc.setTextColor(0);
            doc.setFont("helvetica", "bold");
            
            const headerText = `Challan No.: ${transfer.from_challan?.challan_no || 'N/A'} | From: ${transfer.from_customer?.contact_name} -> To: ${transfer.to_customer?.contact_name}`;
            doc.text(headerText, 18, currentY + 6.5);
            
            const dateText = `Date: ${new Date(transfer.created_at).toLocaleDateString()}`;
            doc.text(dateText, 192, currentY + 6.5, { align: 'right' });

            currentY += 12;

            // Items Table
            const tableHeaders = [['S.No', 'Item Name', 'Qty', 'Rate', 'Amount']];
            const tableData = transfer.items.map((item, idx) => [
                idx + 1,
                item.item_name,
                item.qty,
                Number(item.rate).toFixed(2),
                Number(item.amount).toFixed(2)
            ]);

            doc.autoTable({
                startY: currentY,
                head: tableHeaders,
                body: tableData,
                theme: 'grid',
                headStyles: { fillColor: [40, 40, 40], fontSize: 9 },
                styles: { fontSize: 8 },
                columnStyles: {
                    0: { cellWidth: 12 },
                    2: { halign: 'center' },
                    3: { halign: 'right' },
                    4: { halign: 'right' },
                },
                margin: { left: 14, right: 14 }
            });

            currentY = doc.lastAutoTable.finalY + 10;
        });

        // Footer
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(150);
            doc.text(`Page ${i} of ${totalPages}`, 105, 290, { align: 'center' });
        }

        doc.save(`Site_Transfer_Report_${new Date().getTime()}.pdf`);
    } catch (error) {
        console.error("PDF Error:", error);
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadTransferPdf;